"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.READY = exports.CALL_API = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const axios_1 = __importDefault(require("axios"));
const SearchBar_1 = __importDefault(require("../components/SearchBar"));
const DroneOperatorList_1 = __importDefault(require("../components/drone-operators/DroneOperatorList"));
const Pagination_1 = __importDefault(require("../components/drone-operators/Pagination"));
const moment_1 = __importDefault(require("moment"));
const TIMESTAMP = "utcTimestamp";
const PAGESIZE = "pageSize";
const SEARCHTXT = "searchText";
exports.CALL_API = 0;
exports.READY = 1;
let params = {};
const DroneOperatorsListPage = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const [searchText, setSearchText] = (0, react_1.useState)(props.labels[SEARCHTXT]);
    const [listData, setListData] = (0, react_1.useState)({ data: undefined });
    const [status, setStatus] = (0, react_1.useState)(exports.CALL_API);
    let searchURL = props.apiURL;
    (0, react_1.useEffect)(() => {
        if (status === exports.CALL_API) {
            if (searchText !== props.labels[SEARCHTXT]) {
                params.searchText = searchText;
            }
            if (!params.searchText)
                params.searchText = "";
            let query = "?searchText=" +
                params.searchText +
                "&pageSize=" +
                params.pageSize +
                "&pageNumber=" +
                params.pageNumber;
            axios_1.default
                .get(searchURL + query)
                .then((response) => {
                setStatus(exports.READY);
                setListData({ data: response.data });
                params.pageNumber = 0;
            })
                .catch((error) => console.error(error));
        }
    });
    const submit = (filterState) => {
        if (filterState) {
            if (typeof filterState === "object")
                Object.keys(filterState).forEach((key) => {
                    let filter = filterState[key];
                    if (params[key] && !filter.value)
                        delete params[key];
                    if (filter.value)
                        params[key] = filter.value;
                });
            // reset pagination
            params.pageNumber = 0;
        }
        setStatus(exports.CALL_API);
    };
    const changePagination = (pageNumber) => {
        params.pageNumber = pageNumber;
        submit();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "o-drone-operators", children: [(0, jsx_runtime_1.jsxs)("div", { className: "row justify-content-center", children: [(0, jsx_runtime_1.jsx)("h1", { className: "col-lg-8 text-lg-center", children: props.textHeading }), (0, jsx_runtime_1.jsxs)("div", { className: "col-lg-6 col-md-7", children: [(0, jsx_runtime_1.jsx)("p", { className: "lead a-text-lead", children: props.textIntro }), (0, jsx_runtime_1.jsx)("p", { className: "a-main-content", children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (_a = props.textRich) !== null && _a !== void 0 ? _a : "" } }) }), (0, jsx_runtime_1.jsxs)("p", { className: "lead a-text-lead last-updated", children: [props.labels["lastUpdated"], "\u00A0", (0, jsx_runtime_1.jsx)("span", { id: "index-timestamp", children: props.timestamp ? (0, moment_1.default)(props.timestamp).format("DD.MM.YYYY") : "" })] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "row col-12 col-lg-10 offset-lg-1 mb-3 a-background-box a-background-box--blue", children: (0, jsx_runtime_1.jsx)(SearchBar_1.default, { value: searchText, submitOnEnter: true, onChange: setSearchText, clearInitialValue: true, onSubmit: () => {
                        setStatus(exports.CALL_API);
                    }, onReset: (ev) => {
                        ev.preventDefault();
                        setSearchText("");
                        setStatus(exports.CALL_API);
                    }, onSubmitEnter: () => {
                        setStatus(exports.CALL_API);
                    } }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-12 col-lg-10 offset-lg-1 mb-4", children: params.searchText && ((0, jsx_runtime_1.jsxs)("div", { className: "search-term mb-2", children: ["'", params.searchText, "'", (0, jsx_runtime_1.jsx)("button", { className: "search-term-reset", onClick: (ev) => {
                                ev.preventDefault();
                                setSearchText("");
                                setStatus(exports.CALL_API);
                            }, "aria-label": "Clear search", children: (0, jsx_runtime_1.jsx)("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)("path", { d: "M13.58 0.42C13.02 -0.14 12.18 -0.14 11.62 0.42L7 5.04L2.38 0.42C1.82 -0.14 0.98 -0.14 0.42 0.42C-0.14 0.98 -0.14 1.82 0.42 2.38L5.04 7L0.42 11.62C-0.14 12.18 -0.14 13.02 0.42 13.58C0.7 13.86 0.98 14 1.4 14C1.82 14 2.1 13.86 2.38 13.58L7 8.96L11.62 13.58C11.9 13.86 12.32 14 12.6 14C12.88 14 13.3 13.86 13.58 13.58C14.14 13.02 14.14 12.18 13.58 11.62L8.96 7L13.58 2.38C14.14 1.82 14.14 0.98 13.58 0.42Z", fill: "#F06C00" }) }) })] })) }), listData && listData.data && listData.data.items && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "search-result row col-12 col-lg-10 offset-lg-1 mb-3", children: (0, jsx_runtime_1.jsx)("div", { className: "search-data", children: (0, jsx_runtime_1.jsxs)("div", { className: "numbers", children: [props.labels["shows"], " ", listData.data.items.length, " ", props.labels["of"], " ", listData.data.totalItems, " ", props.labels["droneOperators"]] }) }) }), (0, jsx_runtime_1.jsx)(DroneOperatorList_1.default, { data: listData.data.items, searchParams: params, labels: props.labels }), listData &&
                        listData.data &&
                        Number((_b = listData.data.totalItems) !== null && _b !== void 0 ? _b : 0) > Number((_c = params.pageSize) !== null && _c !== void 0 ? _c : 0) && ((0, jsx_runtime_1.jsx)(Pagination_1.default, { data: { data: { totalItems: Number((_d = listData.data.totalItems) !== null && _d !== void 0 ? _d : 0) } }, params: {
                            pageNumber: Number((_e = params.pageNumber) !== null && _e !== void 0 ? _e : 0),
                            pageSize: Number((_f = params.pageSize) !== null && _f !== void 0 ? _f : 0),
                        }, changePagination: changePagination }))] }))] }));
};
const parseData = (appRootNode) => {
    var _a, _b, _c, _d;
    const data = {};
    try {
        const appData = appRootNode.getAttribute("data-react-props");
        data.apiURL = appData !== null && appData !== void 0 ? appData : "";
        const dataPropsNodeID = "data-props";
        const dataPropsNode = document.getElementById(dataPropsNodeID);
        if (!dataPropsNode)
            console.warn(`${dataPropsNodeID} node not found`);
        else {
            data.textHeading = (_a = dataPropsNode.getAttribute("data-heading")) !== null && _a !== void 0 ? _a : undefined;
            data.textIntro = (_b = dataPropsNode.getAttribute("data-intro")) !== null && _b !== void 0 ? _b : undefined;
            data.textRich = (_c = dataPropsNode.getAttribute("data-rich")) !== null && _c !== void 0 ? _c : undefined;
            let labelStrings = dataPropsNode.getAttribute("data-translations");
            data.labels = labelStrings ? JSON.parse(labelStrings) : {};
            let filterStrings = dataPropsNode.getAttribute("data-filters");
            let parsedData = filterStrings ? JSON.parse(filterStrings) : {};
            data.filters = parsedData.filters;
            // extract timestamp and page size from filter list
            if (parsedData[TIMESTAMP])
                data.timestamp = parsedData[TIMESTAMP];
            params.pageSize = Number((_d = parsedData[PAGESIZE]) !== null && _d !== void 0 ? _d : 0);
            params.pageNumber = 0;
        }
    }
    catch (err) {
        console.error("parseData() fail", err);
    }
    return data;
};
const renderApp = () => {
    const nodeId = "index-drone-operators-root";
    const appRootNode = document.getElementById(nodeId);
    let props;
    if (!appRootNode) {
        console.warn(`Cannot find node with ID '${nodeId}'. The React app cannot be rendered.`);
        return;
    }
    props = parseData(appRootNode);
    (0, client_1.createRoot)(appRootNode).render(react_1.default.createElement(DroneOperatorsListPage, props));
};
renderApp();
exports.default = DroneOperatorsListPage;
